var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      class: {
        warning: !_vm.finalMealId || _vm.loading,
        danger: _vm.showError || _vm.servingNotExists
      }
    },
    [
      _c("th", [_vm._v(_vm._s(_vm.mealType.name))]),
      _vm._v(" "),
      _c(
        "th",
        _vm._l(_vm.selectedMealBadges, function(badge) {
          return _c("div", { key: badge.id }, [
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.showMealBadge(badge.id)
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-link" }),
                _vm._v(" " + _vm._s(badge.name) + "\n      ")
              ]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "active menu-planner-meal-row" },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.mealsLoading && !_vm.loading,
                expression: "mealsLoading && !loading"
              }
            ],
            staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
          }),
          _vm._v(" "),
          _c("singleselect", {
            attrs: {
              checked: _vm.finalMealId,
              disabled: !_vm.canEdit || _vm.loading,
              options: _vm.availableMeals,
              "internal-search": false,
              title: _vm.trans("menu_planner.entity.finalMeal"),
              name: "finalMeal"
            },
            on: {
              "option-selected": function($event) {
                return _vm.save($event)
              },
              "search-change": function($event) {
                return _vm.getMeals($event, 500)
              },
              open: function($event) {
                !_vm.fetchMealsTimeout && _vm.getMeals(null, 0)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("td", [
        _vm.loading
          ? _c("span", {
              staticClass:
                "glyphicon glyphicon-refresh glyphicon-refresh-animate"
            })
          : _c("span", [_vm._v(_vm._s(_vm.finalMealId))])
      ]),
      _vm._v(" "),
      _c("td", [
        _vm.loading
          ? _c("span", {
              staticClass:
                "glyphicon glyphicon-refresh glyphicon-refresh-animate"
            })
          : _c("span", [_vm._v(_vm._s(_vm.selectedMealRate))])
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("td", [
            _c("span", {
              staticClass:
                "glyphicon glyphicon-refresh glyphicon-refresh-animate"
            })
          ])
        : _c(
            "td",
            _vm._l(_vm.selectedMealTagValues, function(tagValue, index) {
              return _c("span", { key: index }, [
                _vm._v("\n      " + _vm._s(tagValue) + "\n      "),
                _c("br")
              ])
            }),
            0
          ),
      _vm._v(" "),
      _vm._l(_vm.baskets, function(basket, index) {
        return _c(
          "td",
          {
            key: index,
            class: { active: index % 2 === 0, "": index % 2 !== 0 }
          },
          [
            _c(
              "table",
              { staticStyle: { "table-layout": "fixed", width: "600px" } },
              [
                _c("tr", [
                  _c("td", { staticStyle: { width: "500px" } }, [
                    _vm._v(_vm._s(_vm.servingName(basket)))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticStyle: { width: "100px" } }, [
                    _vm._v(_vm._s(_vm.basketSize(basket)))
                  ])
                ])
              ]
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7223e14a", { render: render, staticRenderFns: staticRenderFns })
  }
}